export default __webpack_public_path__ + "static/media/1_HandfulOfGems.90aa0d43.png";